import { DataGrid, GridColumns } from "@mui/x-data-grid";
import {
  List, ShowButton, useDataGrid
} from "@refinedev/mui";
import React from "react";

export const ScannerConfigChangesList = () => {
  const { dataGridProps } = useDataGrid();

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 50,
      },
      {
        field: "change_type",
        flex: 1,
        headerName: "Change Type",
        minWidth: 100,
      },
      {
        field: "obj_type",
        flex: 1,
        headerName: "Type",
        minWidth: 100,
      },
      {
        field: "obj_name",
        flex: 1,
        headerName: "Name",
        minWidth: 100,
        renderCell: function render({ row }) {
          return <>{row?.obj_name.split(":")[1].trim()}</>;
        },
      },
      {
        field: "op",
        flex: 1,
        headerName: "Operator",
        minWidth: 200,
        renderCell: function render({ row }) {
          console.log(row?.op);
          return <>{row?.op ? row?.op.match(/<(.+?)>/)?.[1] ?? row?.op : ""}</>;
        },
      },
      {
        field: "ts",
        flex: 1,
        headerName: "Created At",
        type: "number",
        minWidth: 200,
        renderCell: function render({ row }) {
          return <>{new Date(row.ts).toLocaleString()}</>;
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <ShowButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 80,
      },
    ],
    []
  );

  return (
    <List>
      <DataGrid {...dataGridProps} columns={columns} autoHeight />
    </List>
  );
};
